module.exports = __webpack_public_path__ + "static/img/CDP.77862611.png";